import {MW_ERRORS} from 'iqos-mw';
import {useSelector} from 'react-redux';

import {selectConnectionError} from '@/state/selectors/mw';

import ConnectionError from './ConnectionError';

const ConnectionErrorHandler = ({deviceType}) => {
    const isConnectionError = useIsConnectionError();

    if (!isConnectionError) return null;

    return <ConnectionError deviceType={deviceType} />;
};

export default ConnectionErrorHandler;

const useIsConnectionError = () => {
    const connectionError = useSelector(selectConnectionError);

    // If there's no error or the error is not new, don't show the popup
    const hasNoError = !connectionError?.isNew;

    if (hasNoError) return false;

    // Don't show popup for ERROR_DEVICE_REQUEST_CANCELED error
    const isDeviceRequestCanceledError = connectionError.code === MW_ERRORS.ERROR_DEVICE_REQUEST_CANCELED.code;

    if (isDeviceRequestCanceledError) return false;

    // Show popup for all other new errors
    return true;
};
